import React from 'react';
import { Flex } from '../Flex/Flex';
import { BreadcrumbLink } from './BreadcrumbLink';
/**
 * @public
 */
export const Breadcrumbs = ({
  className,
  children
}) => {
  return React.createElement(Flex, {
    className: className
  }, React.Children.map(children, (child, i) => {
    const isLastChild = i === React.Children.count(children) - 1;
    if (React.isValidElement(child)) {
      // @ts-ignore
      return React.cloneElement(child, {
        isLastChild
      });
    }
  }));
};
Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.Link = BreadcrumbLink;